import script from "./CustomerNotesDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerNotesDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerNotesDrawer.vue?vue&type=style&index=0&id=e42e449e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e42e449e"]])

export default __exports__